/**
 * 12 canonical Jubit mascots. CONVENTION-ONLY mirror of
 * `packages/jubit-cli/src/buddy/types.ts` in the sibling jubit-ai-universe repo —
 * KEEP IN SYNC BY HAND. There is NO automated type-parity test enforcing this
 * (an earlier comment claimed one; it never existed). The sibling currently
 * defines only the original 9; kimora/maxie/zhuli are a jubuddy-side superset.
 * To make the alignment importable + enforceable instead of hand-maintained,
 * either sync jubit-cli to 12 (types + mascot-map + sprites + MODEL_PATTERNS) or
 * hoist MascotId + canonical mascot metadata into the shared jubit-sdk package.
 *
 * Sprint 12 (ADR-0007) promoted Kimora / Maxie / Zhuli from Studio-only to
 * playable. Their kits are in HERO_REGISTRY.
 */
export type MascotId =
  | 'jubit'
  | 'cloudra'
  | 'gally'
  | 'gemya'
  | 'grokkie'
  | 'qviki'
  | 'lammie'
  | 'deepo'
  | 'mistra'
  | 'kimora'
  | 'maxie'
  | 'zhuli';

/**
 * 8 original buddy archetypes (iconic fusion results, per pivot notes).
 * These IDs are used when a specific keyword combo triggers a named buddy.
 */
export type OriginalBuddyId =
  | 'bubble-hog'
  | 'bubble-pig'
  | 'ascii-frog'
  | 'pixel-fox'
  | 'ghost-cat'
  | 'robo-crab'
  | 'mecha-bee'
  | 'slime-prince';

/** Union of all buddy identities (both mascot and original). */
export type BuddyId = MascotId | OriginalBuddyId;

export const MASCOT_IDS: readonly MascotId[] = [
  'jubit',
  'cloudra',
  'gally',
  'gemya',
  'grokkie',
  'qviki',
  'lammie',
  'deepo',
  'mistra',
  // Sprint 12 (ADR-0007) promotion
  'kimora',
  'maxie',
  'zhuli',
] as const;

export const ORIGINAL_BUDDY_IDS: readonly OriginalBuddyId[] = [
  'bubble-hog',
  'bubble-pig',
  'ascii-frog',
  'pixel-fox',
  'ghost-cat',
  'robo-crab',
  'mecha-bee',
  'slime-prince',
] as const;
